import type { Provider } from '@angular/core';
import { QuippyApi } from '../transport';

/** Keeps the concrete API service within its owning assistant slice. */
export function provideQuippyTransport(): Provider {
    return QuippyApi;
}

/** Focused session tests replace the transport without exposing its service. */
export function provideQuippyTransportMock(ask: unknown): Provider {
    return { provide: QuippyApi, useValue: { ask } };
}
